import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=a259bcbc&scoped=true&"
import script from "./rules.vue?vue&type=script&lang=js&"
export * from "./rules.vue?vue&type=script&lang=js&"
import style0 from "./rules.vue?vue&type=style&index=0&id=a259bcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a259bcbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a259bcbc')) {
      api.createRecord('a259bcbc', component.options)
    } else {
      api.reload('a259bcbc', component.options)
    }
    module.hot.accept("./rules.vue?vue&type=template&id=a259bcbc&scoped=true&", function () {
      api.rerender('a259bcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/common/rules.vue"
export default component.exports